import React from 'react';
import { timeAgo } from '../api/presence';
import './Presence.css';

// A player's status, as their profile shows it: "Online" with a green dot, or when they were last seen. Shows
// nothing if neither is known, which is how a player who hides their status looks to everyone else.
//   online, lastSeen - from the backend; hidden and mine - the player hides their status, and this is their own
//   view of it, so it is marked as hidden from others
export function Presence({ online, lastSeen, hidden, mine }) {
    let hiddenNote = mine && hidden ? <span className="pf-presence-hidden"> · hidden from others</span> : null;
    if (online) {
        return <p className="pf-presence is-online"><span className="pf-presence-dot" aria-hidden="true"></span>Online{hiddenNote}</p>;
    }
    if (lastSeen) {
        return (
            <p className="pf-presence" title={new Date(lastSeen).toLocaleString()}>
                <span className="pf-presence-dot" aria-hidden="true"></span>Last seen {timeAgo(lastSeen)}{hiddenNote}
            </p>
        );
    }
    return null;
}
